import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import AppNavbar from '@/components/layout/AppNavbar';
import Footer from '@/components/layout/Footer';
import ForgetForm from '@/features/auth/components/ForgetForm';
import HeroSection from '../components/HeroSection';
import LandingSections from '../components/LandingSections';

export default function ForgetPasswordPage() {
  const { t } = useTranslation();
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div>
      <AppNavbar />
      <div className="nav-padding-guest mb-5">
        <HeroSection>
          <Card className="shadow login-card mx-auto border-0 opacity-80 text-wrap">
            <div className="loginbox-title text-center border-bottom position-relative">
              <h2 className="p-3">{t("forget_password")}</h2>
              <Link
                to="/"
                className="position-absolute text-decoration-underline link-primary h5 mb-0"
                style={{ right: '24px', bottom: '24px' }}
              >
                {t("login")}
              </Link>
            </div>
            <Card.Body className="py-2 px-4">
              <ForgetForm />
            </Card.Body>
          </Card>
        </HeroSection>

        <LandingSections onScrollToTop={scrollToTop} />
      </div>
      <Footer />
    </div>
  );
}
